const APP_NAME = 'Scribane';
const TITLE_SEPARATOR = ' | ';

export function formatPageTitle(...parts: Array<string | null | undefined>): string {
  const filtered = parts.filter((part): part is string => Boolean(part?.trim()));
  if (filtered.length === 0) {
    return APP_NAME;
  }
  return [...filtered, APP_NAME].join(TITLE_SEPARATOR);
}
